import React from 'react';
import { getLiftClass, getLiftColor, getLiftStatusColors } from "../../helpers/map";
import LabelLift from "../UI/LabelLift";
import LiftLabelTypeSeat from "./components/LiftLabelTypeSeat";
import LiftLine from "./components/LiftLine";

const Lift14 = ({ isOpen, state, activeLiftId }) => {
	const colors = getLiftColor(isOpen, state);
	return (
		<g id="Lift14" className={getLiftClass(isOpen, activeLiftId === '14', state)}
			 transform="translate(1625.000000, 933.000000)"
		>
			<LiftLine x1="109" y1="55" x2="310.5" y2="139.5" color={colors[0]}/>
			<LiftLine x1="17" y1="16" x2="89.5" y2="47" color={colors[0]}/>

			<LiftLabelTypeSeat
				seatCount="4"
				colors={getLiftStatusColors(state, isOpen)}
				coords="177.954511, 73.500000"
				isOpen={isOpen}
			/>

			<LiftLine x1="354.5" y1="154.5" x2="651.5" y2="252.5" color={colors[0]}/>

			<g id="Labe-lift">
				<circle fill={colors[1]} cx="13" cy="13" r="13"/>
				<circle fill="#FFFFFF" cx="13" cy="13" r="10"/>
			</g>

			<polygon
				fill={colors[2]}
				transform="translate(13.682412, 13.682412) scale(-1, 1) rotate(-23.000000) translate(-13.682412, -13.682412) "
				points="8.18241236 13.6824124 19.1824124 8.18241236 16.8109251 13.6824124 19.1824124 19.1824124"/>

			<LabelLift
				isOpen={isOpen}
				text={<tspan x="-3" y="13">14</tspan>}
				coords="638.000000, 239.000000"
				state={state}/>
		</g>
	);
};


Lift14.propTypes = {};

export default Lift14;
